import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';


@Injectable({
  providedIn: 'root'
})
export class ExamListService {

  private path = '/exams';

  constructor(private backendService: BackendService) { }


  saveExam(examdetails:any) {
  
    return this.backendService.post(this.path + '/save',{examdetails:examdetails});
 
   }              
   
   getExams() {        
    return this.backendService.get(this.path);
  }

 

  deleteExam(id) {

    return this.backendService.post(this.path + '/delete/' + id, {});
}
  

  getExambyId(id) {        
       
    return this.backendService.get(this.path + '/'+ id);
  }  

  saveCostInfo(costinfodetails:any) {

    return this.backendService.post(this.path + '/savecost', costinfodetails);
 
   } 
    
   getExamCostInfo(examid) {        
  
    return this.backendService.get(this.path +'/costinfo/'+ examid);
  }

  deleteExamCostInfo(id) {    
    
    return this.backendService.get(this.path + '/costinfo/delete/'+ id);
  }

  getExamCostInfobyId(id) {        
       
    return this.backendService.get(this.path + '/costinfobyid/'+ id);
  } 
}
